// import React from "react";

// const blogs = [
//   {
//     img: "/images/keyword/5.jpg",
//     title: "14 Seater Urbania on Rent in Pune",
//     desc:
//       "Book 14 seater Force Urbania on rent in Pune for family trips, corporate travel, weddings, and outstation journeys with luxury seating.",
//     link: "/14-seater-urbania-on-rent-in-pune",
//   },
//   {
//     img: "/images/keyword/2.jpg",
//     title: "Urbania on Rent in Pimpri Chinchwad",
//     desc:
//       "Hire Force Urbania in Pune for corporate events, airport transfers, team outings, and conference travel with professional drivers.",
//     link: "/urbania-on-rent-in-pimpri-chinchwad",
//   },
//   {
//     img: "/images/keyword/6.jpg",
//     title: "Urbania on Rent in Kharadi",
//     desc:
//       "Experience premium comfort with luxury Force Urbania bus hire in Pune for weddings, tours, pilgrimages, and long-distance travel.",
//     link: "/urbania-on-rent-in-kharadi",
//   },
// ];

// const LatestBlogs = () => {
//   return (
//     <section className="space overflow-hidden" id="blog-sec">
//       <div className="container">
//         {/* Heading */}
//         <div className="row justify-content-lg-between justify-content-center align-items-end">
//           <div className="col-lg-6">
//             <div className="title-area text-center text-lg-start">
//               <h2 className="sec-title">Latest News & Articles</h2>
//               <p className="sec-text pe-xl-4">
//                 Explore the latest updates, travel tips, and booking guides for
//                 Force Urbania on rent in Pune. Choose the right Urbania for your
//                 comfort and group size.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Blog Cards */}
//         <div className="row gy-4 mt-4">
//           {blogs.map((blog, index) => (
//             <div className="col-xl-4 col-lg-4 col-md-6" key={index}>
//               <div className="blog-card h-100">
//                 <div className="blog-img">
//                   <a href={blog.link}>
//                     <img
//                       src={`${blog.img}`}
//                       alt={blog.title}
//                     />
//                   </a>
//                 </div>

//                 <div className="blog-content">
//                   <h3 className="box-title">
//                     <a href={blog.link}>{blog.title}</a>
//                   </h3>

//                   {/* <p className="box-text">{blog.desc}</p> */}

//                   <a href={blog.link} className="th-btn style3">
//                     Read More <i className="fas fa-arrow-up-right"></i>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default LatestBlogs;
















import React from "react";
import "./LatestBlogs.css";

const blogs = [
  {
    img: "/images/keyword/5.jpg",
    title: "14 Seater Urbania on Rent in Pune",
    desc:
      "Book 14 seater Force Urbania on rent in Pune for family trips, corporate travel, weddings, and outstation journeys with luxury seating.",
    link: "/14-seater-urbania-on-rent-in-pune",
  },
  {
    img: "/images/keyword/2.jpg",
    title: "Urbania on Rent in Pimpri Chinchwad",
    desc:
      "Hire Force Urbania in Pimpri Chinchwad for corporate events, airport transfers, team outings, and conference travel.",
    link: "/urbania-on-rent-in-pimpri-chinchwad",
  },
  {
    img: "/images/keyword/6.jpg",
    title: "Urbania on Rent in Kharadi",
    desc:
      "Experience premium comfort with luxury Force Urbania bus hire in Kharadi for weddings, tours, and pilgrimages.",
    link: "/urbania-on-rent-in-kharadi",
  },
];

const LatestBlogs = () => {
  return (
    <section className="urbania-blog-section">
      <div className="container">
        {/* Section Heading */}
        <div className="section-header text-center">
          {/* <img
            src="/images/logo.jpg"
            alt="Urbania on Rent in Pune"
            className="urbania-logo"
          /> */}
          <h2>Latest Urbania Rental Updates</h2>
          <p>
            Explore premium Force Urbania rental services across Pune with
            professional drivers and luxury comfort.
          </p>
        </div>

        {/* Blog Cards */}
        <div className="row">
          {blogs.map((blog, index) => (
            <div className="col-xl-4 col-lg-4 col-md-6 col-12" key={index}>
              <div className="urbania-blog-card">
                <div className="urbania-blog-img">
                  <a href={blog.link}>
                    <img src={blog.img} alt={blog.title} />
                  </a>
                </div>

                <div className="urbania-blog-content">
                  <h3>{blog.title}</h3>
                  <p>{blog.desc}</p>

                  <a href={blog.link} className="urbania-btn">
                    Read More <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestBlogs;

